/**
 * RecordRTC deja de grabar sin avisar si el micrófono se corta (audífonos bluetooth que cambian
 * de perfil, otra app lo toma). Grabamos de un stream "puente" que no termina y, si el micrófono
 * se corta, lo volvemos a pedir y lo conectamos al mismo puente.
 */
export async function abrirMicrofono () {
  const ctx = new (window.AudioContext || window.webkitAudioContext)()
  const puente = ctx.createMediaStreamDestination()
  let mic = null
  let cerrado = false

  const conectar = async (intentos = 5) => {
    try {
      mic = await navigator.mediaDevices.getUserMedia({ audio: true })
    } catch (e) {
      if (!mic) { ctx.close(); throw e } // sin permiso al iniciar: que el componente lo maneje
      if (intentos <= 1) throw e
      return setTimeout(() => !cerrado && conectar(intentos - 1).catch(() => {}), 400)
    }
    if (cerrado) return mic.getTracks().forEach(t => t.stop())
    ctx.createMediaStreamSource(mic).connect(puente)
    mic.getAudioTracks().forEach(t => { t.onended = () => !cerrado && conectar().catch(() => {}) })
  }

  await conectar()
  return {
    stream: puente.stream,
    cerrar () {
      if (cerrado) return
      cerrado = true
      mic.getTracks().forEach(t => t.stop())
      ctx.close()
    },
  }
}
